import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=cb3cbbf4&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=cb3cbbf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3cbbf4",
  null
  
)

export default component.exports